// Header menu mobile ==================================================
window.addEventListener("DOMContentLoaded", function() {
    /* START ============= MENU MOBILE */
    const smdev_header_nav = document.querySelector('.smdev_header nav');
    const smdev_header_btn_burger = document.querySelector(".smdev_header_btn_burger");
    const smdev_header_btn_burger_div = document.querySelector(".smdev_header_btn_burger div");

    function smdev_handle_menu_mobile(event) {
        if (event.cancelable) {
            event.preventDefault();
        }
        event.stopPropagation(); // Stop event propagation
        smdev_header_nav.classList.toggle("smdev_header_show");
        smdev_header_btn_burger_div.classList.toggle("smdev_close_icon");
        const isMenuOpen = smdev_header_nav.classList.contains("smdev_header_show");
    
        if(isMenuOpen){
            document.body.style.overflow = "hidden";
        }else{
            document.body.style.overflow = "visible";
        }
    }

    function closeMenuIfOpen(event) {
        if(event.target.tagName !== "NAV"){
            if (smdev_header_nav.classList.contains("smdev_header_show")) {
                smdev_header_nav.classList.remove("smdev_header_show");
                smdev_header_btn_burger_div.classList.remove("smdev_close_icon");
                document.body.style.overflow = "visible";
            }
        }
    }

    smdev_header_btn_burger.addEventListener("click", smdev_handle_menu_mobile);
    smdev_header_btn_burger.addEventListener("touchstart", smdev_handle_menu_mobile);
    document.addEventListener("click", closeMenuIfOpen);
    /* END ============= MENU MOBILE */
})
// END Header menu mobile ==============================================




// PROGRESS BAR header =========================
document.addEventListener('DOMContentLoaded', function() {
    function updateProgressBar() {
        const progressBar = document.getElementById('progress-bar');
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = window.innerHeight;
        const scrollTop = window.scrollY;
        const maxScroll = docHeight - winHeight;
        const scrollPercent = (scrollTop / maxScroll) * 100;

        progressBar.style.width = scrollPercent + '%';
    }

    window.addEventListener('scroll', updateProgressBar);
    updateProgressBar();
});
// END PROGRESS BAR header =========================
